(function () {
    'use strict';

    angular
        .module('sod.helper')
        .filter('templateReplacement', templateReplacement);

    const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.

    function templateReplacement(lodash) {
        return function(templateOptions, value) {
            const replacements = lodash.get(templateOptions, 'replacements', false);

            return decodeURI(templateOptions.template).replace(urlReplacerRegex, (match, submatch) => {
                // first check if
                const valuePath = lodash.get(replacements, submatch, submatch);
                return lodash.get(value, valuePath, '');
            });
        }
    }
})();